<template>
  <div>
    <PageHeader title="Abbés Wein des Monats" :subtitle="`im Jahr ${thisYear()}`" class="my-20" />
    <div class="mb-10 px-4 text-xl">
      <p>
        Bitte beachten Sie, dass nicht alle Weine in unser Standardsortiment aufgenommen werden, das heißt: sie sind
        eventuell nur in dem betreffenden Monat verfügbar!
      </p>
      <p>
        Eine detaillierte <strong>Weinbeschreibung</strong> erhalten Sie, wenn Sie auf den Namen des Weines klicken!
      </p>
    </div>
    <div class="mb-10">
      <CampaignTable />
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { de } from 'date-fns/locale'

import CampaignTable from '@/components/campaigns/CampaignTable'
import PageHeader from '@/components/layout/PageHeader'

const DE = { locale: de }

export default {
  components: { CampaignTable, PageHeader },
  methods: {
    thisYear() {
      return format(new Date(), 'yyyy', DE)
    },
  },
}
</script>
